import React, { useEffect } from "react";
import { X, ZoomIn } from "lucide-react";
import { usePinchZoom } from "@/hooks/usePinchZoom";

export function ImageLightbox({ src, alt, onClose }) {
  const { wrapRef, view, gestureRef, zoomTo, onMouseDown, MIN } = usePinchZoom();

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center select-none"
      data-testid="image-lightbox"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 h-11 w-11 rounded-full bg-white/15 backdrop-blur flex items-center justify-center text-white active:scale-90 transition-transform"
        aria-label="Fermer"
      >
        <X className="h-6 w-6" />
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-xs">
        <ZoomIn className="h-3.5 w-3.5" /> Pincez ou double-tapez pour zoomer
      </div>

      <div
        ref={wrapRef}
        className="w-full h-full flex items-center justify-center overflow-hidden touch-none"
        style={{ touchAction: "none" }}
      >
        <img
          src={src}
          alt={alt}
          draggable={false}
          data-testid="lightbox-image"
          onClick={(e) => e.stopPropagation()}
          onDoubleClick={(e) => { e.stopPropagation(); zoomTo(view.scale > 1 ? MIN : 2.5, e.clientX, e.clientY); }}
          onMouseDown={onMouseDown}
          className="max-w-full max-h-full object-contain will-change-transform"
          style={{
            transform: `translate(${view.tx}px, ${view.ty}px) scale(${view.scale})`,
            transition: gestureRef.current.mode ? "none" : "transform 0.18s ease-out",
            cursor: view.scale > 1 ? "grab" : "zoom-in",
          }}
        />
      </div>
    </div>
  );
}
